import fetch from '../../services/fetch'

const deleteFile = (dataList)=> {
    const ids = dataList.map(d => d.id);
    return fetch.post('project/enter/file/delete', ids);
}

const saveProject = (data) => {
    return fetch.post('project/enter/save', data);
}

const getContentById = (id) => {
    return fetch.get('project/enter/get/content/' +id)
}

export default{
    upload : `${fetch.base}project/enter/file`,
    deleteFile,
    saveProject,
    getContentById
}